import { EventsFilterPanel } from "#src/batteries-included-components/Panels/FilterPanels/EventsFilterPanel";
import { EventsTablePanel } from "#src/batteries-included-components/Panels/TablePanels/EventsTablePanel";
import { useStorageKey } from "#src/hooks/useStorageKey";
import React from "react";

export const EventCategoryEventsTab = () => {
  const [filterConfigStorageKey, tableConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["filter-configuration", "table-configuration", "table-state"],
      "events-categories"
    );

  return (
    <>
      <EventsFilterPanel filterConfigStorageKey={filterConfigStorageKey} />
      <EventsTablePanel
        filterConfigStorageKey={filterConfigStorageKey}
        tableConfigStorageKey={tableConfigStorageKey}
        tableStateStorageKey={tableStateStorageKey}
      />
    </>
  );
};
